export const capitalize = (str) => (str ? `${str[0].toLocaleUpperCase()}${str.slice(1)}` : '');

export const sentenceCase = (str) =>
  str ? `${str[0].toLocaleUpperCase()}${str.slice(1).toLocaleLowerCase()}` : '';
